import React from 'react'

export const PageNotFound = () => {
    return (
        <div className="page_not_found">
            404 Page Not Found
        </div>
    )
}
